import { render, staticRenderFns } from "./PresentationsPage.vue?vue&type=template&id=0562c46e&scoped=true&"
var script = {}
import style0 from "./PresentationsPage.vue?vue&type=style&index=0&id=0562c46e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0562c46e",
  null
  
)

export default component.exports